<template>
  <article
    :class="['mmp_event_list', deviceType]"
  >

    <div
      id="content"
      class="content"
    >

      <section class="event_list_wrap">
        <div class="inner">

          <!-- LNB -->
          <!-- NOTE: 사용하지 않음 -->
          <aside class="lnb hidden">
            <p class="tit">EVENT</p>
            <ul class="lnb_list">
              <li>
                <!-- 현재 활성화된 링크에 'active' 클래스 추가 -->
                <a class="link_lnb active">EVENT</a>
              </li>
              <li>
                <a class="link_lnb">추천 클래스</a>
              </li>
            </ul>
          </aside>
          <!-- // LNB -->

          <!-- CONTENT WRAPPER -->
          <div class="wrap_content">

            <!-- 페이지 타이틀 -->
            <h2>{{ boardNm }}</h2>
            <!-- // 페이지 타이틀 -->

            <!-- 리스트 헤더 -->
            <div class="event_list_header">
              <div class="total">
                <span class="txt">총 <em>{{ totCnt }}</em></span>
              </div>
            </div>
            <!-- // 리스트 헤더 -->

            <!-- 이벤트 목록 -->
            <div class="event_list">

              <ul>

                <!-- 진행중인 이벤트가 없는 경우 -->
                <li
                  v-if="dataList.length === 0"
                  class="empty"
                >
                  <div class="inner">
                    <span class="txt">진행중인 이벤트가 없습니다</span>
                  </div>
                </li>
                <!-- // 진행중인 이벤트가 없는 경우 -->

                <!-- 진행중인 이벤트가 있는 경우 -->
                <li
                  v-for="(item, index) in dataList"
                  v-else
                  :key="index"
                  class="event_item"
                >

                  <!-- 썸네일 -->
                  <div class="wrap_thumb">
                    <a class="event_link" href="javascript:void(0);" @click="goDetailPage(item)">
                      <img
                        :src="deviceType === 'pc' ? item.bltndBdtImg : item.bltndBdtImg"
                        :alt="item.bltndTitlNm"
                        class="event_list_thumb"
                      >
                    </a>
                  </div>
                  <!-- // 썸네일 -->
                  <!-- 타이틀 -->
                  <div class="tit">
                    <a class="event_link" href="javascript:void(0);" @click="goDetailPage(item)">
                      <span
                        v-if="item.statusClass"
                        :class="['label', item.statusClass]"
                      >{{ item.status }}</span>
                      <span class="txt">{{ item.bltndTitlNm }}</span>
                    </a>
                  </div>
                  <!-- // 타이틀 -->

                  <!-- 뷰 카운트, 공유 -->
                  <div class="meta">

                    <!-- 뷰 카운트 -->
                    <div class="wrap_cnt">
                      <span class="cnt">{{ item.inqrNum }}</span>
                    </div>
                    <!-- // 뷰 카운트 -->

                    <!-- 공유 -->
                    <div class="wrap_share">
                      <button
                        class="btn_share"
                        @click="share(item)"
                      >공유하기</button>
                    </div>
                    <!-- // 공유 -->

                  </div>
                  <!-- // 뷰 카운트, 공유 -->

                </li>
                <!-- // 진행중인 이벤트가 있는 경우 -->

              </ul>

              <!-- 더보기 -->
              <div
                v-if="totCnt > offset"
                class="wrap_more_btn">
                <button
                  :class="['btn_more', {'active': isStMoreActive}]"
                  type="button"
                  @click="onStMoreClick"
                >더보기</button>
              </div>
              <!-- // 더보기 -->

            </div>
            <!-- // 이벤트 목록 -->

          </div>
          <!-- // CONTENT WRAPPER -->

        </div>
      </section>

    </div>

    <!-- floating navigation -->
    <!-- <CompFloatNav
      v-if="isDesktop"
      :show-ai-tutor="true"
      :show-goto-top="true"
    /> -->
    <!-- // floating navigation -->

    <!-- bottom navigation(MO) -->
    <!-- <NrwBottom v-if="!isDesktop && hasMmpBottomNav" /> -->
    <!-- // bottom navigation(MO) -->

  </article>
</template>
<script>

import commonMixin from '@/mixin/commonMixin'
import { isEmpty } from 'lodash'
import ShareModal from '~pages/nrw/modal/ShareModal.vue' // 공유하기 모달 팝업

export default {
  name: 'BoardMstr',
  components: {
    ShareModal
  },
  mixins: [commonMixin],
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: ' + this.boardNm
    }
  },
  data () {
    return {
      // hasMmpHeader: true, // 헤더 존재 여부
      // hasMmpFooter: true, // 푸터 존재 여부
      eventList: [], // 이벤트 리스트 데이터
      boardNm: '', // 게시판명
      bltndMstrSno: this.$route.query.bltndMstrSno, // 게시판 번호
      offset: isEmpty(this.$route.query.offset) ? 0 : this.$route.query.offset, // OFFSET
      pageLength: isEmpty(this.$route.query.pageLength) ? 9 : this.$route.query.pageLength, // Page Length
      viewType: isEmpty(this.$route.query.viewType) ? 'gallery' : this.$route.query.viewType, // 뷰 타입
      dataList: [], // 게시물 목록
      tocList: [], // 목차 목록
      totCnt: 0, // 게시물 총 개수
      bltndMstr: {}, // 게시판 정보
      noImage: '', // 이미지 없음
      eventStatus: '', // 게시판 제목의 상태값
      eventTitle: '' // 게시판 제목의 상태값 제외 값
    }
  },
  computed: {
    // 더보기 Active 여부
    isStMoreActive () {
      return this.dataList.length !== this.totCnt
    },
    // 현재 디바이스 명 (pc, mobile, tablet)
    deviceType () {
      return window.vue.getStore('homeInfo').state.deviceType
    }
  },
  watch: {

  },
  beforeCreate () {
    if (isEmpty(this.$route.query.bltndMstrSno)) {
      // 게시판 번호 없으면 뒤로..
      // alert이 필요할까..?

      this.$router.back()
    }
  },
  created () {
    this.selectBoardList()
  },
  beforeMount () {

  },
  mounted () {
    if (this.bltndMstrSno === '1002580') {
      this.boardNm = 'EVENT'
    } else {
      this.boardNm = '추천 클래스'
    }
  },
  beforeUpdate () {

  },
  updated () {

  },
  beforeDestroy () {

  },
  methods: {
    // 게시판 목록 조회
    selectBoardList () {
      this.noImage = '/static/images/common/noimage.jpg'

      let params = {
        offset: this.offset,
        pageLength: this.pageLength,
        bltndMstrSno: this.bltndMstrSno,
        viewType: this.viewType
      }
      console.log('selectBoardList params ===>', params)
      this.fetchData('selectBoardList', params, (data) => {
        console.log('dataList Event', data)
        // this.dataList = data.dataList
        this.dataList = [...this.dataList, ...data.dataList]
        this.tocList = data.tocList
        this.bltndMstr = data.bltndMstr
        this.offset = (this.offset + this.pageLength)
        if (isEmpty(this.boardNm)) this.boardNm = this.bltndMstr.bltndNm
        this.totCnt = data.recordsTotal

        const regex = /^\[(.*?)\]\s*(.*)$/
        for ( let i = 0; i < this.dataList.length; i++ ) {
          const match = this.dataList[i].bltndTitlNm.match(regex)
          if (match) {
            this.eventStatus = match[1]
            this.eventTitle = match[2]
          } else {
            this.eventStatus = ''
          }

          this.dataList[i].status = this.eventStatus
          if (this.eventStatus === '진행중') {
            this.dataList[i].statusClass = 'ing'
            this.dataList[i].bltndTitlNm = this.eventTitle
          } else if (this.eventStatus === '당첨자발표') {
            this.dataList[i].statusClass = 'announcement'
            this.dataList[i].bltndTitlNm = this.eventTitle
          } else if (this.eventStatus === '종료') {
            this.dataList[i].statusClass = 'closed'
            this.dataList[i].bltndTitlNm = this.eventTitle
          } else {
            this.dataList[i].statusClass = ''
          }

          /* console.log(' ====> ' + this.eventStatus)
          console.log(' ====> ' + this.eventTitle)
          console.log(' ====> ' + this.dataList[i].bltndTitlNm) */
        }
      }
      )
    },
    goDetailPage (item) {
      // this.$router.push({ name: 'BoardDetail', params: item })
      this.$goPage({name: 'BoardDetail', query: {bltndMstrSno: String(item.bltndMstrSno), bltndSno: String(item.bltndSno), statusClass: item.statusClass, timestamp: new Date().getTime()}})
    },
    // 더보기 버튼 클릭
    onStMoreClick () {
      this.selectBoardList()
    },
    // 공유하기 버튼 클릭 이벤트
    share (item) {
      this.$popup.openModal(this.$el, ShareModal, {
        fullModal: false, // full-page 스타일인 경우 true
        title: '공유하기',
        eventNm: item.bltndTitlNm,
        bltndMstrSno: String(item.bltndMstrSno),
        bltndSno: String(item.bltndSno),
        header: true, // 헤더 사용 여부
        footer: false // 푸터 사용 여부
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/board/BoardMstr.vue